import { render, staticRenderFns } from "./UpdateHistory.vue?vue&type=template&id=038cec04"
import script from "./UpdateHistory.vue?vue&type=script&lang=js"
export * from "./UpdateHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports